import { setTheme } from "theme/default/setTheme";

export const setFontSize_20px = setTheme(({ theme }) => `font-size: ${theme.fontSize.font_size_20px}`);
